<script lang="ts">
    import { errorReporting } from '@shared/error-reporting/ErrorReporting.browser.ts';
    import type { Result } from '@shared/types/utilities.ts';
    import type { TileListInitialSession } from '@tilelist/application/core/TileListInitialSession.ts';
    import TileListPageError from '@tilelist/components/tile-list-error/TileListPageError.svelte';
    import TileListPageController from '@tilelist/components/tile-list-page/TileListPageController.svelte';

    type Props = {
        result: Result<TileListInitialSession>;
    };

    const { result }: Props = $props();

    $effect(() => {
        if (result.state === 'error') {
            errorReporting.report({ error: new Error('No page data'), type: 'initial' });
        }
    });
</script>

{#if result.state === 'error'}
    <TileListPageError />
{:else}
    <TileListPageController initialSession={result.payload} />
{/if}
